import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPurescriptComponent } from './simple-icons-purescript.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPurescriptComponent ],
    exports:      [ SimpleIconsPurescriptComponent ],
    bootstrap:    []
})
export class SimpleIconsPurescriptModule {}
